


























import Vue from 'vue'

import { User } from '@/types/user'

export default Vue.extend({
  name: 'ComponentName',
  props: {
    value: Array,
  },
  data() {
    return {
      users: [] as User[],
    }
  },
  methods: {
    editUser(id: number) {
      this.$router.push(`/cems/setting/user/${id}/edit`)
    },
  },
  watch: {
    value: function(val: User[]) {
      this.users = val
    },
  },
  created() {
    this.users = this.value as User[]
  },
})
